import { Tooltip, Typography } from "antd";
import { EnvironmentOutlined } from "@ant-design/icons";

const { Text } = Typography;

type Props = {
  regionNombre?: string | null;
  comunaNombre?: string | null;
  sectorNombre?: string | null;
  /** Ancho máximo por línea antes de truncar (px). Default 150. */
  maxWidth?: number;
};

/**
 * Celda de "Zona" para tablas: región / comuna / sector apilados en MINI-FILAS
 * (una por nivel) para que se lean sin apretarse. Antes iban en una sola línea
 * `región › comuna › sector` que se truncaba con ellipsis. Región va como línea
 * principal; comuna y sector debajo, atenuadas. El tooltip muestra la ruta completa.
 *
 * Compartido por /agenda-contactos y /costos-sugeridos. Round 2026-07-01.
 */
export default function ZonaCell({
  regionNombre,
  comunaNombre,
  sectorNombre,
  maxWidth = 150,
}: Props) {
  const parts = [regionNombre, comunaNombre, sectorNombre].filter(Boolean) as string[];
  if (!parts.length) return <Text type="secondary">—</Text>;
  const full = parts.join(" › ");
  return (
    <Tooltip title={full}>
      <div style={{ display: "flex", alignItems: "flex-start", gap: 4, lineHeight: 1.3 }}>
        <EnvironmentOutlined style={{ color: "#0369a1", marginTop: 3, flexShrink: 0 }} />
        <div style={{ minWidth: 0 }}>
          {parts.map((p, i) => (
            <div
              key={i}
              style={{
                maxWidth,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                fontSize: i === 0 ? 13 : 12,
                color: i === 0 ? "inherit" : "#64748b",
              }}
            >
              {p}
            </div>
          ))}
        </div>
      </div>
    </Tooltip>
  );
}
